import styled from 'styled-components';

export const SelectContainer = styled.div`
    flex: 1;
    
    div[class*="control"] {
        align-items: center !important;
        display: flex !important;
        min-height: 32px !important;
        height: 32px !important;
        
        > div {
            align-items: center !important;
            display: flex !important;
        }
    }
    
    div[class*="valueContainer"] {
        align-items: center !important;
        display: flex !important;
        padding: 0 8px !important;
        min-height: 32px !important;
        height: 32px !important;
    }
    
    div[class*="singleValue"] {
        margin: 0 !important;
        padding: 0 !important;
        line-height: 1.2 !important;
        position: relative !important;
        top: auto !important;
        transform: none !important;
    }
    
    div[class*="indicatorsContainer"] {
        align-items: center !important;
        display: flex !important;
        height: 32px !important;
    }
    
    div[class*="input"] {
        margin: 0 !important;
        padding: 0 !important;
        align-self: center !important;
    }
    
    div[class*="placeholder"] {
        margin: 0 !important;
        align-self: center !important;
    }
`;

